import React from 'react';
import LogoutUser from 'img/svg/logout-user';
import './HeaderLayout.less';

const { localStorage } = window;


const HeaderLayout = () => {
  // userStorage array, index:0 = picture, index:1 = name
  const [picture, name] = localStorage.getItem('user').split(',');
  return (
    <div className="main-container">
      <div className={picture ? 'svg-container-disabled' : 'svg-container'}>
        { picture ? <img src={picture} className="pic-profile" alt={name} /> : <LogoutUser /> }
      </div>
      <div className="text-container">
        { name || 'Please log in' }
      </div>
    </div>
  );
};


export default HeaderLayout;
